import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { DOWNLOAD_INVALID_FILES, DOWNLOAD_INVALID_FILES_SUCCESS, DOWNLOAD_INVALID_FILES_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* downloadInvalidFiles({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    const { fileId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/file-uploads/${fileId}/logs/INVALID`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: DOWNLOAD_INVALID_FILES_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: DOWNLOAD_INVALID_FILES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_INVALID_FILES_ERROR, payload: error });
  }
}

export function* watchdownloadInvalidFiles() {
  yield takeEvery(DOWNLOAD_INVALID_FILES, downloadInvalidFiles);
}

function* downloadInvalidFilesSaga() {
  yield all([fork(watchdownloadInvalidFiles)]);
}

export default downloadInvalidFilesSaga;
